import 'whatwg-fetch'
import Vue from 'vue'
import VueCollapse from 'vue2-collapse'
import VueSimpleAccordion from 'vue-simple-accordion'
import store from './store'
import { KC } from '@/http/utils'
import initializeVuetify from '@/initializers/vuetify'
import initializeECharts from '@/initializers/echarts'
import initializeAnalytics from '@/initializers/analytics'
import router from './router'
// @ts-ignore
import App from './App.vue'
import VueScrollTo from 'vue-scrollto'
import { ModuleNames } from '@/store/module-names'
import { AppMutationNames } from '@/store/modules/app/keys'

const main = async () => {
  const user = {
    roles: (await KC.getRoles()) || [],
    id: await KC.getUser(),
    firstName: await KC.getUserFirstName(),
    lastName: await KC.getUserLastName(),
  }

  store.commit(`${ModuleNames.app}/${AppMutationNames.updateUserRoles}`, user.roles)
  store.commit(`${ModuleNames.app}/${AppMutationNames.updateUserId}`, user.id)
  store.commit(`${ModuleNames.app}/${AppMutationNames.updateUserFirstName}`, user.firstName)
  store.commit(`${ModuleNames.app}/${AppMutationNames.updateUserLastName}`, user.lastName)

  Vue.use(VueScrollTo, { duration: 200 })
  Vue.use(VueCollapse)
  Vue.use(VueSimpleAccordion)

  initializeAnalytics(user.id)
  initializeECharts()

  const vuetify = initializeVuetify()
  Vue.config.productionTip = false

  new Vue({
    vuetify,
    store,
    router,
    render: h => h(App), // DO NOT remove this line, or router doesn't know how to rend
  }).$mount('#app')
}

main()
  .then(() => {
    console.log('succeeded initialization')
  })
  .catch(err => {
    console.error('initialization failed:', err)
  })
